import { render } from "./email-settings.vue?vue&type=template&id=7366a1d8"
import script from "./email-settings.vue?vue&type=script&lang=js"
export * from "./email-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__